var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row form-group" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.resource("JourneyBuilder_TimerSettings_Duration")))
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row form-group" }, [
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("settings-property", {
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function(ref) {
                  var id = ref.id
                  return [
                    _c("label", { attrs: { for: id } }, [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "JourneyBuilder_TimerSettings_Duration_StartDate_Label"
                          )
                        )
                      )
                    ])
                  ]
                }
              },
              {
                key: "input",
                fn: function(ref) {
                  var id = ref.id
                  return [
                    _c("date-picker", {
                      attrs: {
                        options: {
                          disabled: !_vm.canWrite,
                          typeable: false,
                          id: id
                        }
                      },
                      model: {
                        value: _vm.startDateModel,
                        callback: function($$v) {
                          _vm.startDateModel = $$v
                        },
                        expression: "startDateModel"
                      }
                    })
                  ]
                }
              },
              {
                key: "errors",
                fn: function() {
                  return [
                    _vm.$v.$dirty && _vm.$v.startDate.$invalid
                      ? _c("required-error-message")
                      : _vm._e()
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("settings-property", {
            scopedSlots: _vm._u([
              {
                key: "label",
                fn: function(ref) {
                  var id = ref.id
                  return [
                    _c("label", { attrs: { for: id } }, [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "JourneyBuilder_TimerSettings_Duration_EndDate_Label"
                          )
                        )
                      )
                    ])
                  ]
                }
              },
              {
                key: "input",
                fn: function(ref) {
                  var id = ref.id
                  return [
                    _c("date-picker", {
                      attrs: {
                        options: {
                          disabled: !_vm.canWrite || _vm.isPerpetualModel,
                          typeable: false,
                          disabledDates: {
                            to: _vm.startDateModel
                          },
                          id: id
                        }
                      },
                      model: {
                        value: _vm.endDateModel,
                        callback: function($$v) {
                          _vm.endDateModel = $$v
                        },
                        expression: "endDateModel"
                      }
                    })
                  ]
                }
              },
              {
                key: "errors",
                fn: function() {
                  return [
                    _vm.$v.$dirty && _vm.$v.endDate.$invalid
                      ? _c("required-error-message")
                      : _vm._e()
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row form-group" }, [
      _c("div", { staticClass: "col-6 offset-6" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.isPerpetualModel,
              expression: "isPerpetualModel"
            }
          ],
          attrs: {
            type: "checkbox",
            id: "is-perpetual",
            disabled: !_vm.canWrite
          },
          domProps: {
            checked: Array.isArray(_vm.isPerpetualModel)
              ? _vm._i(_vm.isPerpetualModel, null) > -1
              : _vm.isPerpetualModel
          },
          on: {
            change: function($event) {
              var $$a = _vm.isPerpetualModel,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.isPerpetualModel = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.isPerpetualModel = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.isPerpetualModel = $$c
              }
            }
          }
        }),
        _vm._v(" "),
        _c("label", { attrs: { for: "is-perpetual" } }, [
          _vm._v(
            _vm._s(
              _vm.resource(
                "JourneyBuilder_TimerSettings_Duration_IsPerpetual_Label"
              )
            )
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row form-group" }, [
      _c("div", { staticClass: "col-12" }, [_c("hr")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }